<h1 mat-dialog-title>Are you sure?</h1>
<div mat-dialog-content>
  <p>
    {{data.text}}
  </p>
</div>
<mat-dialog-actions>
  @for(resp of DialogResponse | keyvalue; track resp.value)
  {
    @if (dialogRequires(resp.value)) {
      <button mat-button [mat-dialog-close] tabindex="1" (click)="dialogRef.close(resp.value)">{{resp.key}}</button>
    }
  }
</mat-dialog-actions>
